import React from 'react';
import Message from '@deporvillage/message-component';
import { I18n } from '@deporvillage/utils-library-component';
import { MessageContext } from '../../../context/message/context';
import { RemoveMessage } from '../../../context/message/actions';

const Messages = () => {
    const [state, dispatch] = React.useContext(MessageContext);
    const handleOnClose = () => dispatch(RemoveMessage());

    return (
        state.content ? (
            <div>
                <Message
                    type={state.type}
                    onClose={handleOnClose}
                >
                    <I18n>{state.content}</I18n>
                </Message>
            </div>
        ) : (
            null
        )
    );
};

export default Messages;
